import axios from 'axios';
import { baseUrl, HttpMethods } from '@/api/base';
import type { SignedAssetResponse } from '@/types/Shared';
import type {
  DeleteTdmAssetService,
  GetTdmAssetPayloadType,
  IDeleteTdmService,
  IGetDeliverablesResData,
  IGetMilestonesResData,
  IGetRoverDeliverablesService,
  IGetRoverMilestonesService,
  IGetRoverTasksService,
  IGetRoverTdmResponseAssetData,
  IGetTasksResData,
  IPatchTdmService,
  IPostRoverTdmPayload,
  RoverSignAssetPayload,
  uploadRoverTdmAssetService,
} from './types';

export async function createRoverTdm({ type, payload }: IPostRoverTdmPayload): Promise<any> {
  const res = await axios.request<any>({
    method: HttpMethods.POST,
    url: `${baseUrl.ROVER}/${type}`,
    data: payload,
  });
  return res.data;
}

export async function getRoverTasks({ params }: IGetRoverTasksService): Promise<IGetTasksResData> {
  const res = await axios.request<IGetTasksResData>({
    method: HttpMethods.GET,
    url: `${baseUrl.ROVER}/tasks`,
    params,
  });
  return res.data;
}

export async function getRoverTask(taskId: number) {
  const res = await axios.request({
    method: HttpMethods.GET,
    url: `${baseUrl.ROVER}/tasks/${taskId}`,
  });
  return res.data;
}

export async function getRoverDeliverables({ params }: IGetRoverDeliverablesService): Promise<IGetDeliverablesResData> {
  const res = await axios.request<IGetDeliverablesResData>({
    method: HttpMethods.GET,
    url: `${baseUrl.ROVER}/deliverables`,
    params,
  });
  return res.data;
}

export async function getRoverDeliverable(deliverableId: number) {
  const res = await axios.request({
    method: HttpMethods.GET,
    url: `${baseUrl.ROVER}/deliverables/${deliverableId}`,
  });
  return res.data;
}

export async function getRoverMilestones({ params }: IGetRoverMilestonesService): Promise<IGetMilestonesResData> {
  const res = await axios.request<IGetMilestonesResData>({
    method: HttpMethods.GET,
    url: `${baseUrl.ROVER}/milestones`,
    params,
  });
  return res.data;
}

export async function getRoverMilestone(milestoneId: number) {
  const res = await axios.request({
    method: HttpMethods.GET,
    url: `${baseUrl.ROVER}/milestones/${milestoneId}`,
  });
  return res.data;
}

export async function patchRoverTdm({ tdmType, tdmId, data }: IPatchTdmService) {
  const res = await axios.request({
    method: HttpMethods.PATCH,
    url: `${baseUrl.ROVER}/${tdmType}s/${tdmId}`,
    data,
  });
  return res.data;
}

export async function deleteRoverTdm({ tdmType, tdmId }: IDeleteTdmService) {
  const resp = await axios.request({
    method: HttpMethods.DELETE,
    url: `${baseUrl.ROVER}/${tdmType}s/${tdmId}`,
  });
  return resp.data;
}

export async function getRoverTdmAsset(data: GetTdmAssetPayloadType): Promise<IGetRoverTdmResponseAssetData> {
  const { tdmId, tdmType } = data;
  const res = await axios.request<IGetRoverTdmResponseAssetData>({
    method: HttpMethods.GET,
    url: `${baseUrl.ROVER}/${tdmType}s/${tdmId}/assets`,
  });
  return res.data;
}

export async function uploadRoverTdmAsset(data: uploadRoverTdmAssetService) {
  const { tdmId, tdmType, files } = data;
  const res = await axios({
    method: HttpMethods.POST,
    url: `${baseUrl.ROVER}/${tdmType}s/${tdmId}/assets/save`,
    data: files,
  });
  return res.data;
}

export async function deleteRoverTdmAsset({ assetId, tdmType, tdmId }: DeleteTdmAssetService) {
  const resp = await axios({
    method: HttpMethods.DELETE,
    url: `${baseUrl.ROVER}/${tdmType}s/${tdmId}/assets/${assetId}`,
  });
  return resp.data;
}

export const signRoverTdmFile = async (payload: RoverSignAssetPayload) => {
  const response = await axios.request<SignedAssetResponse>({
    method: HttpMethods.POST,
    url: `${baseUrl.SHERPA}/assets/upload/sign`,
    data: payload,
  });
  return response.data;
};
